"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getText = function (element) {
    var text = element.textContent;
    return text === null ? "" : text;
};
